export default __webpack_public_path__ + "static/media/slide12.a4c957fa.png";